import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-space-info-icon",
  "use": "icon-space-info-icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-space-info-icon\">\n  <circle cx=\"10\" cy=\"10\" r=\"8\" fill=\"#F0F2F7\" />\n  <rect width=\"1\" height=\"1\" transform=\"matrix(1 0 0 -1 9.5 7)\" fill=\"#0444D9\" />\n  <rect x=\"9.5\" y=\"8\" width=\"1\" height=\"6\" fill=\"#0444D9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol